import Page from 'src/guidelines/rate-limiting/index';

export default Page;
